export default function amountToLocaleString(value = null) {
    if (!isNaN(value) && value !== null) {
        return value.toLocaleString();
    } else {
        return "";
    }
}
